import React, {Component} from 'react';
import debug from 'debug';
import {connect} from 'react-redux';
import {DescriptiveText, LoadingSpinner, RadioOption, Steps, Table, Tabs} from '../../../shared';
import axiosInstance from '../../../shared/utils/axios';
import {_openModal, isAuthorized, isEntitled} from '../../../shared/store';
import {_getDefaultContainerID} from '../../reducers/defaultContainerID';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import {gatherData} from '../../../shared/utils/utils';
import ModularReportParameters from './ModularReportParameters';

const log = debug('circleblack:report:modular');

// TODO Support launching this when retrying specifically to the parameters step, no ability to go back based on these parameters?
// return $http.get(NODEJS_API_URL + '/reports/batches/' + batchID + '/retry')
//   .then(function success(res) {
//     var report = lazy(Master.reports).findWhere({id: $scope.batch.reportID});
//     var batchContext = {
//       containerIDs: res.data.containers,
//       dates: res.data.dates,
//       canShare: res.data.canShare,
//     };
//     $scope.$dismiss();
//     return BatchReportsAdvisorModal.open({report: report}, batchContext); // This would launch this from the Notifications Modal
//   });

class ModularReport extends Component {
  constructor(props) {
    super(props);
    this.report = props.report;
    this.containerID = 0;
    this.cancelAction = props.cancelAction;
    this.perfReport = this.report.name === 'Performance Report';
    this.counts = {};
    this.state = {
      // General
      loading: true,
      step: 0,
      // Step 1
      initialContainerID: 0,
      initialContextCounts: {},
      // Step 2
      detailed: [],
      entity: null,
      entityID: null,
    };
    log('constructor state', this.state);
  }

  getCounts = () => Promise.join(
    axiosInstance.get('/containers/' + this.containerID + '/counts'),
    isEntitled([
      {
        group: 'advisorGroups',
        feature: 'core',
        access: 'r',
      },
    ]) ? axiosInstance.get('/advisors/groups', {params: {limit: 1}}) : null,
    (counts, groups) => {
      if (groups && groups.data.length) {
        this.counts = {...counts.data, groups: groups.data.length};
      } else {
        this.counts = counts.data;
      }
    }
  )
    .catch(err => {
      log('error', err);
      throw err;
    });

  setDataManagers = () => {
    this.advisorDataManager = {
      gatherData: inputValue => axiosInstance.get(`/containers/${this.containerID}/advisors`, {params: {...inputValue}})
        .then(res => res.data)
        .catch(function error(err) {
          log('error', err);
          throw err;
        }),
      setSelectedRows: rows => {
        const row = rows[0] || {};
        log('setState advisorDataManager', row[0]);
        let branchRow = this.state.branchRow;
        if (row.id) {
          branchRow = null;
        }
        let newState = {
          advisorRow: row,
          branchRow: branchRow,
        };
        if (row.id || (this.state.advisorRow && this.state.advisorRow.containerID === this.state.initialContainerID)) {
          newState = {
            ...newState,
            initialContainerID: row.containerID,
            initialContextID: row.id,
            initialContextCounts: {
              households: row.counts && row.counts.clients && row.counts.clients.total,
              groups: row.counts && row.counts.groups && row.counts.groups.total,
              accounts: row.counts && row.counts.accounts && row.counts.accounts.total,
            },
            entity: 'ADVISOR',
            entityID: row.id,
          };
        }
        log('advisorDataManager', 'newState', newState);
        this.setState({...newState});
      },
    };

    this.branchDataManager = {
      gatherData: inputValue => axiosInstance.get(`/containers/${this.containerID}/branches`, {params: {...inputValue}})
        .then(res => res.data)
        .catch(function error(err) {
          log('error', err);
          throw err;
        }),
      setSelectedRows: rows => {
        const row = rows[0] || {};
        log('setState branchDataManager', row[0]);
        let advisorRow = this.state.advisorRow;
        if (row.id) {
          advisorRow = null;
        }
        let newState = {
          advisorRow: advisorRow,
          branchRow: row,
          entity: this.state.entity,
          entityID: this.state.entityID,
        };
        if (row.id || (this.state.branchRow && this.state.branchRow.containerID === this.state.initialContainerID)) {
          newState = {
            ...newState,
            initialContainerID: row.containerID,
            initialContextID: row.id,
            initialContextCounts: {
              households: row.counts && row.counts.clients && row.counts.clients.total,
              groups: row.counts && row.counts.groups && row.counts.groups.total,
              accounts: row.counts && row.counts.accounts && row.counts.accounts.total,
            },
            entity: 'BRANCH',
            entityID: row.id,
          };
        }
        log('branchDataManager', 'newState', newState);
        this.setState({...newState});
      },
    };

    this.householdDataManager = {
      gatherData: gatherData(`/containers/${this.containerID}/clients`),
      setSelectedRows: rows => this.setState({detailed: rows}),
    };

    this.accountDataManager = {
      gatherData: input => gatherData(`/containers/${this.containerID}/accounts`)({...input, isNotNull: 'containerID'}),
      setSelectedRows: rows => this.setState({detailed: rows}),
    };
  };

  groupDataManager = {
    gatherData: inputValue => {
      const query = {...inputValue};
      if (this.state.initialContexts.length) {
        if (this.state.initialContext === 'ADVISOR') {
          query.advisorID = this.state.initialContextID;
        } else if (this.state.initialContext === 'BRANCH') {
          query.branchID = this.state.initialContextID;
        }
      }
      return axiosInstance.get('advisors/groups', {params: query})
        .then(res => res.data.map(g => {
          g.containerID = g.id;
          g.shareDisabled = g.households !== 1;
          return g;
        }))
        .catch(function error(err) {
          log('error', err);
          throw err;
        });
    },
    setSelectedRows: rows => this.setState({detailed: rows}),
  };

  preselectedRows = rowName => (this.state && this.state[rowName]) ? [this.state[rowName]] : [];

  // ETODO pass setErrorMessage to Steps
  decrementStep = () => this.setState({
    errorMessage: '',
    step: this.state.step - 1,
    loading: false,
  });

  // ETODO pass setErrorMessage to Steps
  incrementStep = () => this.setState({
    errorMessage: '',
    step: this.state.step + 1,
    loading: false,
  });

  branch = {
    select: {
      max: 1,
      preselectedRows: this.preselectedRows('branchRow'),
      name: 'initialContainerID',
      rowDisabledFunc: row => !(row.counts && row.counts.accounts && row.counts.accounts.total),
    },
  };

  advisor = {
    select: {
      max: 1,
      preselectedRows: this.preselectedRows('advisorRow'),
      name: 'initialContainerID',
      rowDisabledFunc: row => !(row.counts && row.counts.accounts && row.counts.accounts.total),
    },
  };

  household = {
    select: {
      type: 'all',
      max: 100,
      preselectedRows: this.preselectedRows('detailed'),
    },
  };

  account = {
    select: {
      type: 'all',
      max: 100,
      preselectedRows: this.preselectedRows('detailed'),
    },
  };

  group = {
    select: {
      type: 'all',
      max: 100,
      preselectedRows: this.preselectedRows('detailed'),
    },
  };

  componentDidMount() {
    Promise.join(
      this.props.getDefaultContainerID()
        .then(() => {
          this.containerID = this.props.defaultContainerID;
          this.setDataManagers();
          return this.getCounts();
        }),
      () => {
        const counts = this.counts;
        const initialContexts = [];
        const detailedContexts = [];
        let initialContext = 'ADVISOR';
        let initialContextID = this.props.session.profile.id;
        if (isAuthorized(['FIRMMGR', 'CPLO'])) {
          initialContext = 'FIRM';
          if (counts.branches) {initialContexts.push('BRANCHES');}
        }
        if (isAuthorized(['BRANCHMGR', 'FIRMMGR', 'CPLO'])) {
          if (!isAuthorized(['BRANCHMGR'])) {
            initialContext = 'FIRM';
            initialContextID = this.props.session.profile.firm.id;
          } else {
            initialContext = 'BRANCH';
            initialContextID = this.props.session.profile.managedBranches[0].id; // ETODO Allow Branch Managers to choose between branches when they have multiple.
          }
          if (counts.advisors) {initialContexts.push('ADVISORS');}
        }
        if (counts.households) {
          detailedContexts.push('HOUSEHOLD');
        }
        if (counts.accounts) {
          detailedContexts.push('ACCOUNT');
        }
        if (counts.groups) {
          detailedContexts.push('ADVISOR_GROUP');
        }
        this.setState({
          initialContainerID: this.containerID,
          initialContexts,
          initialContext,
          initialContextID,
          initialContextCounts: counts,
          detailedContexts,
          detailedContext: detailedContexts[0],
          loading: false,
          entity: initialContext,
          entityID: initialContextID,
        });
      }
    );
  }

  setErrorMessage = input => this.setState({errorMessage: input});

  render() {
    log('rendering', this.props);
    if (this.state.loading) {
      return <LoadingSpinner/>;
    }

    this.branch.select.preselectedRows = this.preselectedRows('branchRow');
    this.advisor.select.preselectedRows = this.preselectedRows('advisorRow');

    // TODO you probably shouldn't be able to select rows with no hhs/accounts
    const {step, initialContextCounts} = this.state;
    const advisorDataManager = this.advisorDataManager;
    const branchDataManager = this.branchDataManager;
    const householdDataManager = this.householdDataManager;
    const initialTabs = [];
    if (this.state.initialContexts.includes('BRANCHES')) {
      initialTabs.push({
        title: 'Branches',
        value: 'BRANCHES',
        content: <Table dataManager={branchDataManager}
                        columns={[
                          {
                            title: 'Branch',
                            dataPoint: 'name',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          isEntitled([{group: 'advisor', feature: 'primaryCode', access: 'r'}]) && {
                            title: 'Branch Code',
                            dataPoint: 'primaryBranchCode',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          {
                            title: 'Advisors',
                            dataPoint: 'counts.advisors.total',
                            type: 'number',
                            minWidth: 50,
                            isSortable: false,
                          },
                          {
                            title: 'Households',
                            dataPoint: 'counts.clients.total',
                            type: 'number',
                            minWidth: 50,
                            isSortable: false,
                          },
                          {
                            title: 'Accounts',
                            dataPoint: 'counts.accounts.total',
                            type: 'number',
                            minWidth: 50,
                            isSortable: false,
                          },
                          {
                            title: 'Total Assets',
                            dataPoint: 'amount',
                            type: 'currency',
                            minWidth: 50,
                            isSortable: true,
                          },
                        ].filter(c => !!c)}
                        defaultSort={{
                          column: 'id',
                          desc: false,
                        }}
                        searches={[
                          {
                            title: 'Branch',
                            name: 'name',
                            isFuzzy: true,
                          },
                          isEntitled([{group: 'advisor', feature: 'primaryCode', access: 'r'}]) && {
                            title: 'Branch Code',
                            name: 'primaryBranchCode',
                            isFuzzy: true,
                          },
                        ].filter(s => !!s)}
                        select={this.branch.select}
                        rowIdentifier={'id'}
                        height={'500px'}/>,
      });
    }

    if (this.state.initialContexts.includes('ADVISORS')) {
      initialTabs.push({
        title: 'Advisors',
        value: 'ADVISORS',
        content: <Table dataManager={advisorDataManager}
                        columns={[
                          {
                            title: 'Advisor',
                            dataPoint: 'displayName',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          isEntitled([{group: 'advisor', feature: 'primaryCode', access: 'r'}]) && {
                            title: 'Rep Code',
                            dataPoint: 'primaryRepCode',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          {
                            title: 'Households',
                            dataPoint: 'counts.clients.total',
                            type: 'number',
                            minWidth: 50,
                            isSortable: false,
                          },
                          {
                            title: 'Accounts',
                            dataPoint: 'counts.accounts.total',
                            type: 'number',
                            minWidth: 50,
                            isSortable: false,
                          },
                          {
                            title: 'Total Assets',
                            dataPoint: 'amount',
                            type: 'currency',
                            minWidth: 50,
                            isSortable: true,
                          },
                        ].filter(c => !!c)}
                        defaultSort={{
                          column: 'displayName',
                          desc: false,
                        }}
                        searches={[
                          {
                            title: 'Advisor',
                            name: 'displayName',
                            isFuzzy: true,
                          },
                          isEntitled([{group: 'advisor', feature: 'primaryCode', access: 'r'}]) && {
                            title: 'Rep Code',
                            name: 'primaryRepCode',
                            isFuzzy: true,
                          },
                        ].filter(s => !!s)}
                        select={this.advisor.select}
                        rowIdentifier={'id'}
                        height={'500px'}/>,
      });
    }

    const detailedTabs = [];
    if (initialContextCounts.households) {
      detailedTabs.push({
        title: 'Households',
        value: 'HOUSEHOLD',
        content: <Table dataManager={householdDataManager}
                        columns={[
                          {
                            title: 'Household',
                            dataPoint: 'displayName',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          {
                            title: 'Clients',
                            dataPoint: 'clientCounts',
                            type: 'number',
                            minWidth: 50,
                            isSortable: false,
                          },
                          {
                            title: 'Accounts',
                            dataPoint: 'totalAccounts',
                            type: 'number',
                            minWidth: 50,
                            isSortable: true,
                          },
                          {
                            title: 'Total Assets',
                            dataPoint: 'amount',
                            type: 'currency',
                            minWidth: 50,
                            isSortable: true,
                          },
                        ]}
                        defaultSort={{
                          column: 'displayName',
                          desc: false,
                        }}
                        searches={[
                          {
                            title: 'Household',
                            name: 'displayName',
                            isFuzzy: true,
                          },
                        ]}
                        select={this.household.select}
                        rowIdentifier={'id'}
                        height={'500px'}/>,
      });
    }
    if (initialContextCounts.accounts) {
      detailedTabs.push({
        title: 'Accounts',
        value: 'ACCOUNT',
        content: <Table dataManager={this.accountDataManager}
                        columns={[
                          {
                            title: 'Account',
                            dataPoint: 'searchName',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          isEntitled([{group: 'advisor', feature: 'accountCode', access: 'r'}]) && {
                            title: 'Account Code',
                            dataPoint: 'code',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          {
                            title: 'Client',
                            dataPoint: 'clientDisplayName',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          {
                            title: 'Type',
                            dataPoint: 'typeName',
                            type: 'text',
                            minWidth: 50,
                            isSortable: true,
                          },
                          {
                            title: 'Assets',
                            dataPoint: 'balance',
                            type: 'currency',
                            minWidth: 50,
                            isSortable: true,
                          },
                        ].filter(c => !!c)}
                        defaultSort={{
                          column: 'searchName',
                          desc: false,
                        }}
                        searches={[
                          {
                            title: 'Account',
                            name: 'searchName',
                            isFuzzy: true,
                          },
                          isEntitled([{group: 'advisor', feature: 'accountCode', access: 'r'}]) && {
                            title: 'Account Code',
                            name: 'code',
                            isFuzzy: true,
                          },
                          {
                            title: 'Type',
                            name: 'typeName',
                            isFuzzy: true,
                          },
                        ].filter(s => !!s)}
                        select={this.account.select}
                        rowIdentifier={'id'}
                        height={'500px'}/>,
      });
    }
    if (this.counts.groups) {
      detailedTabs.push({
        title: 'Groups',
        value: 'ADVISOR_GROUP',
        content: <>
          <Table dataManager={this.groupDataManager}
                 columns={[
                   {
                     title: 'Name',
                     dataPoint: 'name',
                     type: 'text',
                     minWidth: 50,
                     isSortable: true,
                   },
                   {
                     title: 'Type',
                     dataPoint: 'subtypeDisplayName',
                     type: 'text',
                     minWidth: 50,
                     isSortable: false,
                   },
                   {
                     title: 'Accounts',
                     dataPoint: 'accounts',
                     type: 'number',
                     minWidth: 50,
                     isSortable: false,
                   },
                   {
                     title: 'Assets',
                     dataPoint: 'amount',
                     type: 'currency',
                     minWidth: 50,
                     isSortable: true,
                   },
                 ]}
                 defaultSort={{
                   column: 'name',
                   desc: false,
                 }}
                 searches={[
                   {
                     title: 'Name',
                     name: 'name',
                     isFuzzy: true,
                   },
                 ]}
                 select={this.group.select}
                 rowIdentifier={'id'}
                 height={'500px'}/>
        </>,
      });
    }

    const initialContextSelection = <div>
      <DescriptiveText>Your initial context is the high level view of data points to include in generated reports.</DescriptiveText>
      <RadioOption label={`${isAuthorized(['BRANCHMGR']) ? 'Branch' : 'Firm'} Level View`}
                   selected={this.state.initialContainerID === this.containerID}
                   dataPoint={{
                     name: 'initialContainerID',
                     value: this.containerID,
                   }}
                   onChange={() => {
                     if (advisorDataManager.toggleAllPageRowsSelected) {
                       this.advisorDataManager.toggleAllPageRowsSelected(false);
                     }
                     if (branchDataManager.toggleAllPageRowsSelected) {
                       this.branchDataManager.toggleAllPageRowsSelected(false);
                     }
                     this.setState({
                       initialContext: isAuthorized(['BRANCHMGR']) ? 'BRANCH' : 'FIRM',
                       entity: isAuthorized(['BRANCHMGR']) ? 'BRANCH' : 'FIRM',
                       entityID: isAuthorized(['BRANCHMGR']) ? this.props.session.profile.managedBranches[0].id : this.props.session.profile.firm.id,
                       initialContainerID: this.containerID,
                       advisorRow: null,
                       branchRow: null,
                     });
                   }}/>
      <Tabs
        tabs={initialTabs}
        displayTabTitles={true}
        tabWidth='150px'
        minTabWidth='70px'
        defaultSelection={
          initialTabs.some(tab => tab.value === this.state.initialContext)
            ? initialTabs.findIndex(tab => tab.value === this.state.initialContext)
            : 0
        }
        onChange={tabIndex => {
          this.setState({initialContext: initialTabs[tabIndex].value});
        }}
      />
    </div>;

    const detailedContextSelection = <div>
      <DescriptiveText>The detailed context is the specific set(s) of data to generate for.</DescriptiveText>
      <Tabs
        tabs={detailedTabs}
        displayTabTitles={true}
        tabWidth='150px'
        minTabWidth='70px'
        defaultSelection={detailedTabs.findIndex(tab => tab.value === 'HOUSEHOLD')}
        onChange={tabIndex => this.setState({
          detailed: [],
          detailedContext: detailedTabs[tabIndex].value,
        })}
      />
    </div>;

    // TODO Do something as a loading screen as a step transaction and cancel button for steps
    return <Steps
      height={'100%'}
      completedStateContent={<DescriptiveText>{this.state.successMessage || ''}</DescriptiveText>}
      steps={[
        this.state.initialContexts.length && {
          title: `Generate ${this.report.name} - Select Initial Context`,
          content: initialContextSelection,
          next: {
            action: () => this.incrementStep(),
            disabled: !(this.state.initialContainerID && this.state.initialContext),
          },
        },
        {
          title: `Generate ${this.report.name} - Select Detailed Context`,
          content: detailedContextSelection,
          ...(this.state.initialContexts.length && {
            previous: {
              action: () => {
                this.setState({
                  detailed: [],
                  detailedContext: this.state.detailedContexts[0],
                });
                this.decrementStep();
              },
            },
          }),
          next: {
            action: () => {
              this.incrementStep();
            },
            disabled: !this.state.detailed.length,
          },
        },
        {
          title: `Generate ${this.report.name} - Select Parameters`,
          content: <ModularReportParameters
            report={this.report}
            setProcessing={input => this.setState({processing: input})}
            initialContainerID={this.state.initialContainerID}
            detailedContext={this.state.detailedContext}
            detailed={this.state.detailed}
            setCanGenerate={input => this.setState({canGenerate: input})}
            setErrorMessage={this.setErrorMessage}
            setSuccessMessage={input => this.setState({successMessage: input})}
            setStep={input => this.setState({step: input})}
            entity={{
              entity: this.state.entity,
              entityID: this.state.entityID,
            }}
            handleError={msg => {
              this.setState({
                step: step - 1,
              });
              setTimeout(() => this.setState({
                errorMessage: msg,
              }), 100);
            }}
          />,
          previous: {
            action: () => {
              this.decrementStep();
            },
          },
          next: {
            label: 'Generate',
            action: 'SUBMIT',
            disabled: !this.state.canGenerate, // ETODO useState
          },
          form: 'modularReportParameters',
        },
      ].filter(s => !!s)}
      processing={this.state.processing}
      stepIndex={step}
      canStepBack={true}
      cancelAction={this.cancelAction}
      setErrorMessage={this.setErrorMessage}
      errorMessage={this.state.errorMessage}/>;
  }
}

const mapStateToProps = state => ({
  session: state.session,
  defaultContainerID: state.defaultContainerID,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  getDefaultContainerID: () => dispatch(_getDefaultContainerID()),
});

ModularReport.propTypes = {
  /**
   * The Report to be generated
   */
  report: PropTypes.shape({}).isRequired,
  /**
   * Is from Models Reducer
   */
  openModal: PropTypes.func.isRequired,
  /**
   * Is from Default Container Reducer
   */
  getDefaultContainerID: PropTypes.func.isRequired,
  /**
   * Is from Default Container Reducer
   */
  defaultContainerID: PropTypes.number.isRequired,
  /**
   * To reset the Report generate tile to default state
   */
  cancelAction: PropTypes.func.isRequired,
  /**
   * Is Session Reducer
   */
  session: PropTypes.shape(
    {
      profile: PropTypes.shape(
        {
          firm: PropTypes.shape(
            {id: Number}
          ).isRequired,
          id: PropTypes.number.isRequired,
          managedBranches: PropTypes.array,
        }
      ).isRequired,
    }
  ).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModularReport);
